/**
 * Longest text an application form field may hold, by field uid. A field not
 * listed here has no limit.
 *
 * The applicant's form and the reviewer's Edit Application page both render
 * their fields through RenderField, which reads this list, so a limit set
 * here applies to both. The backend keeps the same list
 * (civic-plan-backend/utils/fieldCharacterLimits.js) and refuses a longer
 * value; add a new field in both places.
 */
export const FIELD_CHARACTER_LIMITS: Readonly<Record<string, number>> = {
  address: 250,
  /** Existing Road width approaching to plot; its column is varchar(10). */
  road_leading_to_land: 10,
};

/** The character limit of a field, or undefined when it has none. */
export function getFieldCharacterLimit(fieldUid: string): number | undefined {
  return FIELD_CHARACTER_LIMITS[fieldUid];
}
